import { useCurrentUser } from './useCurrentUser';

export function useIsAdmin(): boolean {
  const { data } = useCurrentUser();
  return !!data?.isAuthenticated && data.roles.some(r => r.toLowerCase() === 'admin');
}
